<button mat-raised-button
  (click)="onClick()"
  class="cta-btn w-100">
  {{'COMMON.LABEL.REQUEST_INFOS' | translate}}
  <!-- <span *ngIf="publicBundle.numberOfVehicles === 1">
  </span>
  <span *ngIf="publicBundle.numberOfVehicles > 1">
    {{'COMMON.LABEL.ACTIVATE_INVESTMENT_BUNDLE' | translate}}
  </span> -->
</button>